var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuResourceGenerationAndManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72168 2.37894C10.8778 1.8732 13.1222 1.8732 15.2783 2.37894C18.4253 3.11721 20.8828 5.57473 21.6211 8.72171C22.1268 10.8778 22.1268 13.1222 21.6211 15.2784C20.8828 18.4253 18.4253 20.8828 15.2783 21.6211C13.1222 22.1269 10.8777 22.1269 8.72168 21.6211C5.5747 20.8828 3.11718 18.4253 2.3789 15.2784C1.87316 13.1222 1.87316 10.8778 2.3789 8.72171C3.11718 5.57476 5.57472 3.11722 8.72168 2.37894ZM4.18359 9.87894C3.89814 11.5168 3.94538 13.1979 4.32617 14.8213C4.89092 17.2289 6.77105 19.1091 9.17871 19.6739C9.77954 19.8148 10.3884 19.9084 11 19.958V9.87894H4.18359ZM13 9.87894V19.958C13.6115 19.9084 14.2204 19.8148 14.8213 19.6739C17.2289 19.1091 19.1091 17.229 19.6738 14.8213C20.0546 13.1979 20.1019 11.5168 19.8164 9.87894H13ZM14.4228 4.24027C12.6904 3.89382 10.9018 3.92202 9.17871 4.32621C7.22481 4.78453 5.61824 6.10911 4.78027 7.87894H19.2197C18.3817 6.1091 16.7752 4.78453 14.8213 4.32621L14.4228 4.24027Z",
    fill: "#091B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuResourceGenerationAndManage);
export default __webpack_public_path__ + "static/media/menu_resourceGenerationAndManage.d387a8434ff927df4bb2ee96f7c0be30.svg";
export { ForwardRef as ReactComponent };